import $ from '@sparta.global.vendors/jquery';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import workflowUtility from '@sparta.digital-mortgage-application.utilities/workflow-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <p id=\"modalLayerTimeoutContentDescription\" class=\"message-body\">\r\n    "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"modalLayerTimeoutContent") : stack1)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"text1") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </p>\r\n  <div class=\"dme-modal-actions\">\r\n    "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"returnToApplicationButton") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":7,"column":47}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"layerContent") : stack1)) != null ? lookupProperty(stack1,"modalLayerTimeoutContent") : stack1),{"name":"layerContent","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":9,"column":17}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.digital-mortgage-application.modules/timeout-module",
  "version": "2.0.1",
  "id": "timeoutModule",
  "containerID": "digitalMortgageApplicationTimeoutModule",
  "moduleName": "digital-mortgage-application-timeout-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "timeoutModule",
  "data": {
    "init": "timeoutModuleJS",
    "options": {
      "copy": "{{json copy}}"
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link,
        layerContent,
        button
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link,
    layerContent,
    button
  },
  "dependencies": {
    "@sparta.digital-mortgage-application.utilities/workflow-utility": "^2.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* globals spaParams */

/**
 * Timeout module sparta class
 */
class TimeoutModuleJS extends Module {
  /**
   * Constructs a sparta module class
   * @param {Object} options Sparta options
   * @param {Object} context Sparta context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.id = options.target.id;
    this.$target = `(#${this.id})`;
  }

  /**
   * Initializes the module, called after the page is loaded.
   * @returns {void}
   */
  init() {
    const $timeoutModal = $('#modalLayerTimeoutContent');
    const {
      heartbeatIntervalMilliseconds,
      inactivityTimeoutMilliseconds,
      redirectTimeoutMilliseconds,
      timeoutUrl
    } = this.settings.copy.timeoutSettings;
    const inactivityTimeout = inactivityTimeoutMilliseconds;
    const heartbeatInterval = heartbeatIntervalMilliseconds;
    const redirectTimeout = redirectTimeoutMilliseconds;
    const timeoutURL = timeoutUrl;
    let currentTime = new Date().getTime();
    let timeOfLastEvent = new Date().getTime();
    $timeoutModal.find('#returnToApplicationButtonLarge').on('click', () => {
      spartaUILayersUtility.closeLayer('modalLayerTimeoutContentSpartaUILayer');
    });

    /**
     * Records the time of the last user interaction with the system
     * @returns {void}
     */
    function recordTime() {
      // if the timeout modal is already onscreen, we can assume the user is inactive
      if (!$timeoutModal.is(':visible')) {
        timeOfLastEvent = new Date().getTime();
      }
    }

    // we will treat click, input, blur, and scroll events as user activity
    document.addEventListener('click', recordTime);
    document.addEventListener('input', recordTime);
    document.addEventListener('blur', recordTime);
    document.addEventListener('scroll', recordTime);

    // also record time of last session refresh
    spartaEventsUtility.sub('DME.AJAX.SUCCESS', recordTime);

    /**
     * Performs heartbeat and timeout actions depending on interval
     * @note short interval - maybe show timeout modal or log user out
     * @returns {void}
     */
    function heartbeat() {
      currentTime = new Date().getTime();
      const elapsedTimeBetweenEvents = currentTime - timeOfLastEvent;
      if (inactivityTimeout < elapsedTimeBetweenEvents) {
        // don't try to show the modal if it is already active
        if (!$timeoutModal.is(':visible')) {
          spartaUILayersUtility.openLayer($timeoutModal);
          $timeoutModal.triggerHandler('focus');
        }
        if (redirectTimeout < elapsedTimeBetweenEvents) {
          spartaEventsUtility.pub('log-event', {
            messageId: 'dma-inactive-session-timeout',
            messageText: `Session has timed out after [${elapsedTimeBetweenEvents}] seconds.`,
            priority: 'INFO'
          });
          // window.location redirection magics
          window.location.replace(timeoutURL);
        }
      }
    }

    // initialize heartbeat after the predefined interval has elapsed, after page loads
    setInterval(heartbeat, heartbeatInterval);

    /**
     * @note long interval - refresh the session if the user has been active recently
     * @returns {void}
     */
    function maybeRefreshSession() {
      if (!$timeoutModal.is(':visible')) {
        // if the timeout modal isn't already onscreen
        currentTime = new Date().getTime();
        const elapsedTimeBetweenEvents = currentTime - timeOfLastEvent;
        // and the user has been active in the last 30 seconds
        if (elapsedTimeBetweenEvents < 30000) {
          const route = workflowUtility.getCurrentRoute();
          $.ajax({
            // then let's refresh the session
            url: spaParams.siteParams.secureHost + route.endpoints.init,
            dataType: 'text',
            success: () => {
              // we aren't using ajax-utility here, so we have to record this timestamp ourselves
              timeOfLastEvent = new Date().getTime();
            }
          });
        }
      }
    }
    setInterval(maybeRefreshSession, inactivityTimeout);
  }
}

/* istanbul ignore next */

registerModuleClass({
  moduleClass: TimeoutModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { TimeoutModuleJS as default, moduleConfig };
